<template>
	<div
		class="w-full overflow-hidden whitespace-nowrap"
		:class="`${blok.background_color || ''} ${blok.text_color || ''}`"
	>
		<div
			class="block"
			:class="[
				blok.auto_scroll && !isSingleItem && 'running-text',
				pauseOnHover && 'pause',
				blok.auto_scroll && isSingleItem && 'running-text-single'
			]"
		>
			<ul
				class="flex items-center"
				:class="[
					!blok.auto_scroll
						? 'justify-center gap-5 md:gap-0 overflow-x-auto'
						: '',
					isSeparator && 'px-5 !gap-5 md:!justify-center !justify-start'
				]"
				:style="{ minHeight: `${blok.height}px` }"
			>
				<li
					v-for="(item, index) in duplicatedItems"
					:key="index"
					class="flex justify-center basis-1 md:basis-1/5"
					:class="[
						!blok.auto_scroll ? '' : 'min-w-max px-5 xl:px-32 flex-grow',
						isSingleItem && '!basis-1 md:!min-w-full',
						isSeparator &&
							`!basis-auto gap-5 items-center first:before:hidden before:content-[''] before:block before:w-[1px] before:h-3 before:bg-current`
					]"
				>
					<StoryblokComponent :blok="item" class="flex justify-center" />
				</li>
			</ul>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { RunningText } from "~/types/storyblok/storyblok";

interface Props {
	blok: RunningText;
	isSingleItem?: boolean;
	isSeparator?: boolean;
	pauseOnHover?: boolean;
}

const MIN_ITEMS = 5;

const { blok, isSingleItem } = defineProps<Props>();

const duplicatedItems = computed(() => {
	if (!blok.items.length) return [];

	if (!blok.auto_scroll) {
		return blok.items;
	}

	let result = [...blok.items];
	const itemCount = blok.items.length;
	const minCount = (isSingleItem ? 1 : MIN_ITEMS) * 2;

	while (result.length < minCount) {
		result = [
			...result,
			...blok.items.slice(
				0,
				result.length + itemCount <= minCount
					? itemCount
					: minCount - result.length
			)
		];
	}

	return result;
});
</script>

<style scoped>
.running-text {
	animation: runningText 50s linear infinite;
}

.running-text-single {
	animation: runningText 50s linear infinite;
}

.pause:hover {
	animation-play-state: paused;
}

@keyframes runningText {
	0% {
		transform: translate3d(0, 0, 0);
	}
	100% {
		transform: translate3d(-100%, 0, 0);
	}
}

@media screen and (min-width: 768px) {
	.running-text-single {
		animation: runningText 50s linear infinite;
	}
}
</style>
